import store from 'store'

export default client => {
  client.interceptors.request.use(config => {
    if (store.state.auth.token) {
      config.headers['Authorization'] = `Bearer ${store.state.auth.token}`
    }

    return config
  })
}
